import { render, staticRenderFns } from "./UuidWidget.vue?vue&type=template&id=2afc5558&scoped=true&"
import script from "./UuidWidget.vue?vue&type=script&lang=js&"
export * from "./UuidWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc5558",
  null
  
)

export default component.exports